import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ContainerScrollModule } from '@app/components/container-scroll/container-scroll.module';
import { HeaderModule } from '@app/components/header/header.module';
import { ListItemsModule } from '@app/components/list-items/list-items.module';
import { TabScrollSpyModule } from '@app/components/tab-scroll-spy/tab-scroll-spy.module';
import { LazyModule } from '@app/shared';
import { SharedModule } from '@app/shared/shared.module';

import { ArtistsComponent } from '../artists/artists.component';
import { ArtistsRoutingModule } from './artists-routing.module';

@NgModule({
  declarations: [
    ArtistsComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    HeaderModule,
    ArtistsRoutingModule,
    ContainerScrollModule,
    TabScrollSpyModule,
    LazyModule,
    ListItemsModule
  ]
})
export class ArtistsModule { }
